import {createApp} from 'vue'
import App from "@/App.vue";
import { createPinia } from "pinia";
import {createVuetify} from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import router from "./router";
import {loadTheme, vuetify} from "@/plugins/vuetify";
import {useTenantStore} from "@/stores/tenantStore";

const pinia = createPinia();
const app = createApp(App);

async function renderApp() {
  let vuetifyOverride = vuetify;
  try {
    vuetifyOverride = await loadTheme();
  } catch (e) {
    console.error(e);
  }

  app.use(router).use(pinia).use(createVuetify(vuetifyOverride)).mount('#app');

  useTenantStore().setDefaultTheme({
    primary: vuetifyOverride.theme.themes.currentTheme.colors?.primary || vuetify.theme.themes.currentTheme.colors.primary,
    secondary: vuetifyOverride.theme.themes.currentTheme.colors?.secondary || vuetify.theme.themes.currentTheme.colors.secondary,
    tertiary: vuetifyOverride.theme.themes.currentTheme.colors?.tertiary || vuetify.theme.themes.currentTheme.colors.tertiary,
  })
}

renderApp();